/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import SmileScanMobile from '@brands/Dashboard/Dashboard/Patient/utils/smile_scan_mobile.svg';
import uploadImage from '@brands/Dashboard/PatientForms/PatientForm/ImageUpload/assets/drag-image-icon.svg';
import useSubscribe, { Subscriber } from '@brands/hooks/useSubscribe';
import { setUserWebState } from '@brands/services/auth/setUserWebState';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setForm } from '@brands/store/slices/patientFormSlice';
import store from '@brands/store/store';
import SelectInput from '@brands/Components/Inputs/SelectInput/SelectInput';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { displayErrorDetails } from '@brands/Utils/displayError';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import CancelIcon from '@mui/icons-material/Cancel';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '@brands/Dashboard/PatientForms/utils/icons/linearProgressBarLogo.svg';
import closeIcon from '@brands/Dashboard/PatientForms/utils/icons/linearProgressBarClose.svg';
import { Button } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Container from '../../../../Components/Container/Container';
import ProgressBar from '../../../../Components/ProgressBar/ProgressBar';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import MobileHandoffModal from './Components/MobileHandoffModal';
import styles from './styles.module.scss';
import LinearProgressDisplay from '@brands/Components/ProgressDisplay/ProgressDisplay';
import { selectCommonCustomStylesSlim } from '@brands/Utils/customStyles';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';

type Option = {
  value: any;
  label: string;
};

const QRLearnMore = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const screenSize = useWindowSize();
  const isMobile = screenSize.width < 768;
  const { state, search } = useLocation();
  const { userInfo } = useAppSelector(selectAuth);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const [useintraoralCamera, setUseIntraoralCamera] = useState(false);
  const [loading, setLoading] = useState(false);
  const [displayMobileHandOffModal, setDisplayMobileHandOffModal] = useState(false);
  const queryParams = useMemo(() => queryString.parse(search), [search]);
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const [cameraDevices, setCameraDevices] = useState<MediaDeviceInfo[]>([]);
  const currentState: Record<number, string> = useAppSelector(selectCurrentPatientState);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
  const [capturedImages, setCapturedImages] = useState<string[]>([]);
  const videoRef = useRef<HTMLVideoElement>(null);

  const [newUrl, setNewUrl] = useState('');

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const videoDevices = devices.filter((d) => d.kind === 'videoinput');
      setCameraDevices(videoDevices);
      if (videoDevices.length > 0) setSelectedDeviceId(videoDevices[0].deviceId);
    });
  }, []);

  const subscriber: Subscriber = useMemo(
    () => ({
      onMessage: (message: Record<string, any>) => {
        if (['mobile_handoff'].includes(message.command)) {
          setDisplayMobileHandOffModal(true);
        } else if (['mobile_case_creation_complete'].includes(message.command)) {
          setDisplayMobileHandOffModal(false);
          goToDashboard();
        }
      },
      commands: ['mobile_handoff', 'mobile_case_creation_complete'],
    }),
    [setDisplayMobileHandOffModal],
  );
  const { subscribe, unsubscribe } = useSubscribe();

  useEffect(() => {
    const subscriptionId = subscribe(subscriber);

    return () => unsubscribe(subscriptionId);
  }, [subscribe, unsubscribe, subscriber]);

  const appendStateToUrl = (jwtToken: string): string => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    // Set the 'auth' parameter with the JWT token
    url.searchParams.set('auth', encodeURIComponent(jwtToken));

    return url.toString();
  };

  const goToDashboard = useCallback(() => {
    if (
      userInfo.role.name === UserRoleName.Admin ||
      userInfo.role.name === UserRoleName.SuperAdmin ||
      userInfo.role.name === UserRoleName.OrganizationAdmin
    ) {
      navigate(`/admin/review-profile/Patient/${state.patientId}`);
    } else {
      roleNavigate('/dashboard');
    }
  }, [userInfo.role.name, navigate, roleNavigate]);

    useEffect(() => {
    const fetchDataAndSetState = async (): Promise<void> => {
      setLoading(true);
      if (!queryParams.state) {
        // Retrieve and compress the Redux state
        const reduxState = store.getState();

        // Extract only the needed parts
        const { auth, pageState } = reduxState;

        // Create a new object with the selected parts
        const selectedState = {
          auth,
          patientForm: reduxState.patientForm,
          selectedPatient: currentPatient,
          pageState,
          patientcurrentOrganization: currentOrganization,
          patientcurrentOrganizationPrices: currentOrganizationPrices,
          refreshToken: Cookies.get('refreshToken'),
          jwtTokenExpire: Cookies.get('jwtTokenExpire'),
          patientState: userInfo.id in currentState ? { [userInfo.id]: currentState[userInfo.id] } : {},
        };

        // Set User Web State
        try {
          await setUserWebState(selectedState);
        } catch (error: unknown) {
          displayErrorDetails(error);
        }

        setNewUrl(appendStateToUrl(Cookies.get('jwtToken') as string));
        setLoading(false);
      }
    };
    if (queryParams.auth === undefined) {
      fetchDataAndSetState();
    }
  }, [queryParams]);

  useEffect(() => {
    if (useintraoralCamera) {
      if (!selectedDeviceId) return;

      navigator.mediaDevices.getUserMedia({ video: { deviceId: { exact: selectedDeviceId } } }).then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      });

      return () => {
        if (videoRef.current?.srcObject instanceof MediaStream) {
          videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        }
      };
    }
  }, [selectedDeviceId, useintraoralCamera]);

  const onBack = (): void => {
    if (useintraoralCamera) {
      const videoElement = document.querySelector('video');
      const stream = videoElement?.srcObject as MediaStream | null;

      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      setUseIntraoralCamera(false);
    } else {
      dispatch(setForm([...values!]));
      navigate(-1);
    }
  };

  const captureImage = () => {
    if (!videoRef.current) return;
    const canvas = document.createElement('canvas');
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
      const imageUrl = canvas.toDataURL('image/png');
      setCapturedImages([...capturedImages, imageUrl]);
    }
  };

  const deleteImage = (index: number) => {
    const updatedImages = [...capturedImages];
    updatedImages.splice(index, 1);
    setCapturedImages(updatedImages);
  };

  const cameraOptions: Option[] = cameraDevices.map((device) => ({
    value: device.deviceId,
    label: device.label || 'Camera',
  }));

  if (loading) {
    return <Loading fullScreen />;
  }

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess={true}
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.patientSelectTopDivContainer}>
          <div className={styles.patientSelectTopDiv}>
            <div className={styles.patientSelectTopDivFirst}>
              <img src={logo} className={styles.patientSelectTopDivFirstLogo} />
              <img src={closeIcon} className={styles.patientSelectTopDivFirstClose} onClick={goToDashboard} />
            </div>
            <LinearProgressDisplay progress={10} />
          </div>
        </div>
          <div className={styles.uploadImageContainerDiv}>
            <div className={styles.uploadImageContainerDivFirst}>
              <div className={styles.uploadImageContainerDivFirstLeft}>
                <span className={styles.uploadImageContainerDivFirstLeftHeader}>
                How to scan a QR code
                </span>
                <span className={styles.getReady}>
                Here’s a quick 4 step process on how to scan a QR code to use our guided image capture.
                </span>
              </div>
            </div>

            <div className={styles.uploadImageContainerDivFooter}>
              <Button onClick={onBack} className={styles.backBtn}>
                <ArrowBackIosIcon />
                Back
              </Button>
            </div>
          </div>

        {displayMobileHandOffModal && <MobileHandoffModal />}
      </div>
    </Container>
  );
};
export default QRLearnMore;
